
export class Segment {

    segmentIndex: number = 0;
    // length:number = 0;
    // angle:number = 0;

    constructor(public Length: number, public Angle: number) {
        // this.length = length;
        // this.angle = angle;
    }

    clone() {
        return new Segment(this.Length, this.Angle);
    }

}